import { Box, Grid, Skeleton } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import Section from 'modules/contracts/components/ContractDetails/Section'

const LoadingState = () => {
  return (
    <Section icon="inbox" title={i18n.t('contract_versions.other_information.title')}>
      <Grid variant="fixed">
        <Box gridColSpan={{ xxs: 12, xs: 6, s: 6 }} gap="s8">
          <Skeleton width="s80" height="s8" />
          <Skeleton width="s140" height="s8" />
        </Box>
        <Box gridColSpan={{ xxs: 12, xs: 6, s: 6 }} gap="s8">
          <Skeleton width="s80" height="s8" />
          <Skeleton width="s140" height="s8" />
        </Box>
        <Box gridColSpan={{ xxs: 12, xs: 6, s: 6 }} gap="s8">
          <Skeleton width="s80" height="s8" />
          <Skeleton width="s140" height="s8" />
        </Box>
        <Box gridColSpan={{ xxs: 12, xs: 6, s: 6 }} gap="s8">
          <Skeleton width="s80" height="s8" />
          <Skeleton width="s140" height="s8" />
        </Box>
        <Box gridColSpan={{ xxs: 12, xs: 6, s: 6 }} gap="s8">
          <Skeleton width="s80" height="s8" />
          <Skeleton width="s140" height="s8" />
        </Box>
        <Box gridColSpan={{ xxs: 12, xs: 6, s: 6 }} gap="s8">
          <Skeleton width="s80" height="s8" />
          <Skeleton width="s140" height="s8" />
        </Box>
      </Grid>
    </Section>
  )
}

export default LoadingState
